/**
 * Generates a CSV string from a 2D array and triggers a download.
 * - Uses UTF-8 BOM for Excel compatibility with accented characters
 * - Properly escapes double quotes in cell values
 *
 * @param rows - 2D array where first row is typically headers
 * @param filename - Name of the downloaded file (should end with .csv)
 */
export function downloadCsv(rows: string[][], filename: string): void {
  const csvContent = rows.map((row) => row.map((cell) => `"${(cell ?? '').replace(/"/g, '""')}"`).join(',')).join('\n')

  // BOM for UTF-8 to ensure Excel opens with correct encoding
  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.append(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
